import { Autocomplete, Box, CircularProgress, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { chartOfAccountTypeLabels } from "@/features/chart-of-accounts";
import { CustomInputField } from "@/features/ui";

export const InventoryAdjustmentAccountSelect = ({
  value,
  onChange,
  options,
  loading = false,
  disabled = false,
  TextFieldProps,
}) => {
  // Keep the selected account visible even if it is no longer part of the
  // configured preference accounts (e.g. the preference changed after saving).
  const mergedOptions =
    value && !options.some((option) => option.id === value.id)
      ? [value, ...options]
      : options;

  return (
    <Autocomplete
      value={value || null}
      onChange={(_, newValue) => onChange(newValue)}
      options={mergedOptions}
      loading={loading}
      disabled={disabled}
      getOptionLabel={(option) => `${option.code} - ${option.name}`}
      renderOption={(renderProps, option) => {
        const { key, ...otherProps } = renderProps;
        return (
          <Box component="li" key={key} {...otherProps}>
            <Box>
              <Typography variant="body2">
                {option.code} - {option.name}
              </Typography>
              <Typography variant="caption" sx={{ color: "text.secondary" }}>
                {chartOfAccountTypeLabels[option.type]}
              </Typography>
            </Box>
          </Box>
        );
      }}
      isOptionEqualToValue={(option, selectedOption) =>
        option.id === selectedOption.id
      }
      renderInput={(params) => (
        <CustomInputField
          {...TextFieldProps}
          {...params}
          InputProps={{
            ...params.slotProps.input,
            ...TextFieldProps?.InputProps,
            endAdornment: (
              <>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.slotProps.input.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

InventoryAdjustmentAccountSelect.propTypes = {
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  TextFieldProps: PropTypes.object,
};
